<template>
  <div id="app" class="app">
    <PageBody />

<!--    <ReloadPwaModal />-->
    <DevtoolsTheme />
    <NotificationWrapper />
    <portal-target name="root"></portal-target>
    <ModalRenderer />
    <WayfinderModal />
  </div>
</template>

<script>
import PageBody from '@/components/page-body/PageBody'
import ReloadPwaModal from '@/components/modals/ReloadPwaModal'
import DevtoolsTheme from '@/components/devtools/Theme'
import NotificationWrapper from '@/components/notification-wrapper/NotificationWrapper'
import Modal from '@/components/modals/Modal'
import ModalRenderer from '@/components/modal-renderer/ModalRenderer'
import WayfinderModal from '@/components/wayfinder-modal/WayfinderModal'

export default {
  name: 'App',
  components: {
    PageBody,
    ReloadPwaModal,
    DevtoolsTheme,
    NotificationWrapper,
    Modal,
    ModalRenderer,
    WayfinderModal
  },
  computed: {
    modalOpen() {
      return this.$store.state.modal.open
    },
    modalData() {
      return this.$store.state.modal.data
    }
  },
  async mounted () {
    await this.$store.dispatch('app/initialize', this)
  },
  methods: {
    handleError () {
      setTimeout(() => {
        this.$refs.errorWrapper.reset()
      }, 5000)
    }
  }
}
</script>

<style lang="scss">
.app {
  position: relative;
  max-width: 600px;
  height: calc(100vh - calc(env(safe-area-inset-bottom, -34px ) + 34px));
  /*height: calc(100vh - env(safe-area-inset-top));*/
  margin: auto;
  box-shadow: 0 0 30px 5px color(dark, 0.01);
  /*padding-top: constant(safe-area-inset-top); !* iOS 11.0 *!*/
	/*padding-top: env(safe-area-inset-top); !* iOS 11.2 *!*/
}
</style>
